import React from 'react';
import MemoryResurrectionEngine from './components/MemoryResurrectionEngine';

function App() {
  return (
    <div className="App">
      <MemoryResurrectionEngine />
    </div>
  );
}

export default App;